
define('app/join/joinMain',[
	'domReady',
	'app/join/joinApp',
	'app/common/setup'
], function(domReady, JoinApp, Setup){
	domReady(function () {
		Setup.initialize();
		JoinApp.initialize();
    });
});